var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "w-100 h-100", attrs: { id: "login" } }, [
    _c("div", { staticClass: "d-flex justify-center justify-content-center" }, [
      _c(
        "div",
        {
          staticClass:
            "content h-100 d-flex flex-column justify-content-center align-items-center",
          staticStyle: {
            width: "45%",
            "margin-top": "50px",
            transition: "1s all",
          },
        },
        [
          _c(
            "div",
            { staticClass: "content-form", staticStyle: { width: "60%" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                  },
                },
                [_c("SupsisLogo"), _vm._v(" "), _c("language-switch")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "50px",
                    color: "#183b56",
                    "font-weight": "700",
                    "font-size": "35px",
                  },
                },
                [
                  _vm._v(
                    "\n                    E-posta doğrulama\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "25px", color: "#183b56" } },
                [
                  _vm.status === "success"
                    ? _c(
                        "a-alert",
                        { attrs: { type: "success", "show-icon": "" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "message" }, slot: "message" },
                            [_vm._v("E-posta adresiniz doğrulandı.")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              attrs: { slot: "description" },
                              slot: "description",
                            },
                            [
                              _vm._v(
                                "Artık Supsis hesabınıza giriş yapabilirsiniz."
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.status === "error"
                    ? _c(
                        "a-alert",
                        { attrs: { type: "error", "show-icon": "" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "message" }, slot: "message" },
                            [_vm._v("Davet bağlantısı doğrulanamadı.")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              attrs: { slot: "description" },
                              slot: "description",
                            },
                            [_vm._v(_vm._s(_vm.errorMessage))]
                          ),
                        ]
                      )
                    : _c(
                        "a-alert",
                        { attrs: { type: "info", "show-icon": "" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "message" }, slot: "message" },
                            [_vm._v("Davet bağlantınız kontrol ediliyor.")]
                          ),
                        ]
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass:
                    "w-100 text-white text-center font-weight-bold d-block",
                  staticStyle: {
                    background: "#183b56",
                    "border-radius": "8px",
                    padding: "13px 0",
                    "font-size": "15px",
                    "margin-top": "20px",
                  },
                  attrs: { to: "/login" },
                },
                [
                  _vm._v(
                    "\n                    Giriş ekranına dön\n                "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }